
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReviewDoneSet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"establishment_uid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"review_done_set"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"establishment_uid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"establishment_uid"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"author"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"author_url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created_on"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"link_on_platform"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mark"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title_fr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title_native"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"text_fr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"text_native"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"positive"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"published_on"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scrap_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scraped_on"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nb_message"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updated_on"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"journey_date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"photo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"establishment_scrap_url_type"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"platform"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"logo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"logo2"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"native_lang"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"current_state"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"class_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"active"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"verbose_name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"answerer"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstname"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullname"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"establishment"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"logo"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":791}};
    doc.loc.source = {"body":"query ReviewDoneSet($establishment_uid: String) {\r\n  review_done_set(establishment_uid: $establishment_uid) {\r\n    author\r\n    author_url\r\n    created_on\r\n    link_on_platform\r\n    mark\r\n    title_fr\r\n    title_native\r\n    text_fr\r\n    text_native\r\n    positive\r\n    published_on\r\n    scrap_id\r\n    scraped_on\r\n    uid\r\n    nb_message\r\n    updated_on\r\n    journey_date\r\n    photo\r\n    establishment_scrap_url_type {\r\n      name\r\n    }\r\n    platform {\r\n      name\r\n      logo\r\n      logo2\r\n    }\r\n    native_lang {\r\n      code\r\n    }\r\n    current_state {\r\n      class_name\r\n      active\r\n      data\r\n      uid\r\n      verbose_name\r\n    }\r\n    answerer {\r\n      uid\r\n      lastname\r\n      firstname\r\n      fullname\r\n    }\r\n    establishment {\r\n      name\r\n      uid\r\n      logo\r\n    }\r\n  }\r\n}\r\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["ReviewDoneSet"] = oneQuery(doc, "ReviewDoneSet");
        
